/**
 * 倉庫API
 * 倉庫の情報を取得
 */

import { apiGet } from './client';
import type { Warehouse, WarehouseTreeNode } from '@/lib/types';

// 後方互換性のため、型を再エクスポート
export type { Warehouse } from '@/lib/types';

/**
 * 倉庫一覧を取得
 */
export async function getWarehouses(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<Warehouse[]> {
  return apiGet<Warehouse[]>(`/${accountCode}/warehouses`, authHeaders);
}

/**
 * 倉庫ツリー（店舗グループ階層→倉庫のプレオーダー平坦リスト）を取得
 * 並び順はプロダクト（owen）の倉庫ツリーと同じ seller_group_warehouse_trees.sort_order 順
 */
export async function getWarehouseTree(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<WarehouseTreeNode[]> {
  return apiGet<WarehouseTreeNode[]>(`/${accountCode}/warehouses/tree`, authHeaders);
}
